export default "__VITE_ASSET__CtSaUo2Y__"